import { render, staticRenderFns } from "./PreliminaryExamImage.vue?vue&type=template&id=52f81acf&"
import script from "./PreliminaryExamImage.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryExamImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports